import React from "react";
import PropTypes from "prop-types";
import Card from "react-bootstrap/Card";
import { iconHelper } from "../../utils/utils";
import StatusSection from "./StatusSection";
import ResultDetailsSection from "./ResultDetailsSection";
import ViewResultButton from "./ViewResultButton";
import NextTestNotice from "./NextTestNotice";
import { calculateNextTestCountdown } from "../../utils";
const ResultCard = ({
  report,
  report_link,
  test_name,
  dateCollected,
  dateReported,
  test_type,
  downloadButton,
  resultDetails,
  testReportValue,
  showCard = true,
  isMobile,
  reportPublishedDate,
  isVitaminB12Flag,
  vitabinB12reportPublishedDate,
  vitaminMarkerValue,
  dNAReportPublishedDate,
  doctor_name
}) => {
  const testIcon = iconHelper(test_name);
  const timeLeft = calculateNextTestCountdown(reportPublishedDate, testReportValue, "Vitamin B12");
  const timeLeftvitamin = calculateNextTestCountdown(vitabinB12reportPublishedDate, vitaminMarkerValue, "Vitamin B12");
  
  const isVenous = localStorage.getItem('isVenousBlood') == 'true';
  const renderCardContent = () => {
    const titleClass = `test-title ageo-bold ${report && "fs-24"}`;
    return (
      <div className="d-flex align-items-center fs-15 test-details">
         {/* {resultDetails && (<img
          className="me-2 result-card-img"
          src={testIcon}
          width={85}
          height={85}
          alt="Test Icon"
        />)} */}
        <div className="flex-column w-100">
          <h5 className={titleClass}>{test_name}</h5>
          {!report && <StatusSection date={reportPublishedDate} dNAReportPublishedDate={dNAReportPublishedDate}/>}
          {resultDetails && (
            <ResultDetailsSection
              dateCollected={dateCollected}
              dateReported={dateReported}
              doctorName={doctor_name}
              isVenous={isVenous}
            />
          )}
          {!report && (
            <div className="mt-2">
              <ViewResultButton report_link={report_link} />
            </div>
          )}
        </div>
      </div>
    );
  };

  // ---------- MAIN RENDER ----------
  if (!showCard) {
    return (
      <div
        className={`result-card p-3 d-flex ${
          report ? "align-items-start" : "align-items-center"
        } justify-content-between mb-4`}
      >
        {renderCardContent()}
        {report && <div className="d-flex align-items-center pt-0 pb-0 p-3 px-0">{downloadButton}</div>}
        <NextTestNotice test_type={test_type} timeLeft={timeLeft} />
      </div>
    );
  }

  return (
    <Card className="result-card d-flex justify-content-between mb-4">
      {isMobile ? (
        <div className="align-items-center fs-15 test-details flex-column">
          <div className="d-flex align-items-center">
            <div className="d-flex flex-column mt-2 text-center">
              <h5 className={`mb-1 test-title ${report && "fs-24"}`}>{test_name}</h5>
              {!report && <StatusSection date={reportPublishedDate} />}
              {resultDetails && (
                <ResultDetailsSection
                  dateCollected={dateCollected}
                  dateReported={dateReported}
                  doctorName={doctor_name}
                />
              )}
            </div>
          </div>
          {!report && (
            <div className="mobile-view mt-2">
              <ViewResultButton report_link={report_link} />
            </div>
          )}
        </div>
      ) : (
        <div className="col-xl-6 col-12">
          {renderCardContent()}
        </div>
      )}
      {report && <div className="d-flex align-items-center p-3">{downloadButton}</div>}
      <div className="col-xl-6 col-12"><NextTestNotice test_type={test_type} timeLeft={timeLeft}  isVitaminB12Flag={isVitaminB12Flag} vitabinB12reportPublishedDate={vitabinB12reportPublishedDate} timeLeftvitamin={timeLeftvitamin}/></div>
    </Card>
  );
};

ResultCard.propTypes = {
  report: PropTypes.object,
  report_link: PropTypes.string,
  test_name: PropTypes.string.isRequired,
  dateCollected: PropTypes.string,
  dateReported: PropTypes.string,
  test_type: PropTypes.string,
  downloadButton: PropTypes.node,
  resultDetails: PropTypes.bool,
  testReportValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  showCard: PropTypes.bool,
  isMobile: PropTypes.bool,
  reportPublishedDate: PropTypes.string,
  dNAReportPublishedDate: PropTypes.string,
  isVitaminB12Flag: PropTypes.bool,
  vitabinB12reportPublishedDate: PropTypes.string,
  vitaminMarkerValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  doctor_name: PropTypes.string  
};

export default ResultCard;
